import React from "react";
import { Modal, ModalHeader, ModalTitle } from "react-bootstrap";

const ReasonModal = ({ show, children, close }) => {
  
  return (
    <Modal show={show} centered animation onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default ReasonModal;
